<template>
  <aside class="side_menu" :class="{ expand: showSideBar }">
    <ul class="pt-5">
      <h5>ProgramArea</h5>
      <li v-for="(item, i) in sideData" :key="i" class="nav-item">
        <div class="form-check">
          <label class="form-check-label">
            <input
              type="checkbox"
              class="form-check-input"
              name=""
              id=""
              value="checkedValue"
            />
            1st Anc Visit
          </label>
        </div>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: "DashboardSideMenu",
  props: {
    showSideBar: {
      type: Boolean,
      required: true,
      showSideBar: false,
    },
    sideData: {
      type: Array,
      required: true,
      default: () => [
        {
          name: "",
          link: "",
          icon: "",
        },
      ],
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
aside.side_menu {
  position: fixed;
  width: 250px;
  top: 66px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  max-height: 100vh;
  overflow-y: auto;
  -webkit-transition: 1s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  transition: 1s cubic-bezier(0.68, -0.55, 0.27, 1.55);
  background-color: #ffffff;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-size: 0.9rem;
  padding: 1.5rem;
  ul {
    list-style: none;
    padding-left: 0;
    li {
      margin-bottom: 1rem;
      a {
        display: flex;
        height: 100%;
        align-items: center;
        justify-content: flex-start;
        color: #59595e;
        border-radius: 0.2rem;
        transition: all ease 0.5s;
        &.nav-link {
          white-space: nowrap;
          span.title {
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 15ch;
            padding-left: 0.4rem;
          }
        }
        &.active {
          background: #004aad;
          color: white;
        }
        &:hover {
          background: #004bad8f;
          color: #1a1a1a;
        }
      }
    }
  }
  &.expand {
    width: 250px;
    margin-left: 0;
    ul li a.nav-link {
      transition: 0.25s ease-in-out;
      white-space: nowrap;
    }
  }
}
@media screen and (max-width: 810px) {
  aside.side_menu {
    margin-left: -250px;
    top: 0;
  }

  aside.expand {
    width: 250px;
    margin-left: 0;
  }
}
</style>
